import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  disabled?: boolean;
  onPlaceOrder: () => Promise<{
    provider?: string;
    redirect_url?: string;
  } | null>;
}

export default function StancerRedirectSection({ onPlaceOrder, disabled }: Props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function pay() {
    setLoading(true);
    setError(null);
    try {
      const r = await onPlaceOrder();
      // SC-574: `null` means the order was refused upstream (expired slot,
      // incomplete address, unavailable product…) and the parent has already
      // shown the real reason. Reporting a provider misconfiguration on top of
      // it contradicted that message — stay silent and let the toast stand.
      if (!r) return;
      if (r.provider !== 'stancer' || !r.redirect_url) {
        setError(t('checkout.stancer.unexpectedProvider'));
        return;
      }
      window.location.assign(r.redirect_url);
    } catch {
      // The raw exception message is developer text (and often English); the
      // customer gets the translated payment-failure message instead.
      setError(t('checkout.stancer.failed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="stancer-section">
      <p className="font-mono text-sm text-ink/70">
        {t('checkout.stancer.notice')}
      </p>
      <button
        type="button"
        onClick={pay}
        disabled={loading || disabled}
        className="w-full bg-mint border-2 border-ink rounded-btn px-6 py-3 font-display shadow-stamp-sm disabled:opacity-50"
      >
        {loading
          ? t('checkout.stancer.preparing')
          : t('checkout.stancer.pay')}
      </button>
      {error && <p className="mt-2 font-mono text-sm text-sale-red">{error}</p>}
    </div>
  );
}
